import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { formatDate } from '../../services/helpers';
import styles from './PostList.module.css';

function PostList({ posts }) {
  const navigate = useNavigate();

  const postsWithThumbnails = useMemo(() => {
    return posts.map(p => {
      if (p.thumbnail) {
        try {
          // Dynamically import thumbnail images
          const thumbnailUrl = new URL(
            `../posts/${p.url}/resources/thumbnail.png`,
            import.meta.url
          ).href;
          return { ...p, thumbnail: thumbnailUrl };
        } catch (err) {
          console.warn(`Could not load thumbnail for ${p.url}`, err);
          return p;
        }
      }
      return p;
    });
  }, [posts]);

  const handleNavTo = (url) => {
    navigate(`/${url}`);
  };

  return (
    <div id="post-list">
      {postsWithThumbnails.map((post) => (
        <div
          key={post.url}
          onClick={() => handleNavTo(post.url)}
          className={styles.postCard}
        >
          {post.thumbnail ? (
            <div className={styles.postCardWithThumbnail}>
              <div className={styles.postCardMain}>
                <img
                  className={styles.postThumbnail}
                  src={post.thumbnail}
                  alt={post.title}
                />
                <div className={styles.postInfo}>
                  <h2>{post.title}</h2>
                  <p>{post.description}</p>
                </div>
              </div>
              <div className={styles.postFoot}>
                <span className={styles.postAuthor}>
                  <a
                    onClick={(e) => e.stopPropagation()}
                    href={post.author.url}
                    className="evergreen"
                  >
                    {post.author.name}
                  </a>
                </span>
                {' | '}
                <span className={styles.postDate}>
                  {formatDate(post.publishDate, 'med')}
                </span>
              </div>
            </div>
          ) : (
            <div className={styles.postCardNoThumbnail}>
              <div className={styles.postInfo}>
                <h2>{post.title}</h2>
                <p>{post.description}</p>
              </div>
              <div className={styles.postFoot}>
                <span className={styles.postAuthor}>
                  <a
                    onClick={(e) => e.stopPropagation()}
                    href={post.author.url}
                    className="evergreen"
                  >
                    {post.author.name}
                  </a>
                </span>
                {' | '}
                <span className={styles.postDate}>
                  {formatDate(post.publishDate, 'med')}
                </span>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default PostList;
